<gk-map [mapState]="ecoMapState" (dispatch)="handleMapAction($event)"></gk-map>
